import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap'
import { formatErrorResponse } from '../utils/errorHandlers'
import { stockItemCategoryAPI } from '../api/stockItemCategoryAPI'
import { usePermissions } from '../contexts/PermissionContext'

function StockItemCategoryUpdateScreen() {
    const { hasPermission, loading: permissionsLoading } = usePermissions()
    const { id } = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState(null)
    const [category, setCategory] = useState({
        name: '',
    })

    useEffect(() => {
        async function fetchCategory() {
            try {
                const data = await stockItemCategoryAPI.getById(id);
                setCategory(data)
            } catch (error) {
                console.error('Error fetching category:', error)
                setError('Failed to load category data')
            }
        }
        fetchCategory()
    }, [id])

    const submitHandler = async (e) => {
        e.preventDefault()
        try {
            await stockItemCategoryAPI.update(id, category);
            navigate('/stock-item-categories')
        } catch (error) {
            setError(formatErrorResponse(error))
        }
    }

    const handleDelete = async () => {
        if (!window.confirm('Are you sure you want to delete this category?')) {
            return;
        }

        try {
            await stockItemCategoryAPI.delete(id);
            navigate('/stock-item-categories')
        } catch (error) {
            console.error('Error deleting category:', error);
            setError(formatErrorResponse(error))
        }
    };

    if (permissionsLoading) {
        return (
            <Container className="py-3">
                <div className="text-center">Loading...</div>
            </Container>
        )
    }

    if (!hasPermission('stock.categories.modify')) {
        return (
            <Container className="py-3">
                <Alert variant="danger">
                    You don&apos;t have permission to update stock item categories.
                </Alert>
            </Container>
        )
    }

    return (
        <Container>
            <Row className="justify-content-left">
                <Col md={8} lg={6}>
                    <h1>Update Stock Item Category</h1>
                    <Form onSubmit={submitHandler}>
                        <Form.Group className="mb-4" controlId="name">
                            <Form.Label>Name*</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter name"
                                value={category.name}
                                onChange={(e) => setCategory({ ...category, name: e.target.value })}
                                required
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>
                        {error && (
                            <Alert variant="danger" onClose={() => setError(null)} dismissible>
                                {error}
                            </Alert>
                        )}
                        <Row className="mt-3">
                            <Col>
                                <Button 
                                    variant="primary" 
                                    type="submit" 
                                    className="me-2"
                                >
                                    Update
                                </Button>
                                <Button 
                                    variant="danger"
                                    onClick={handleDelete}
                                    className="me-2"
                                >
                                    Delete
                                </Button>
                                        <Button 
                                            variant="outline-primary" 
                                            onClick={() => navigate('/stock-item-categories')}
                                        >
                                            <i className="fas fa-arrow-left me-2"></i>
                                            Back to List
                                        </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default StockItemCategoryUpdateScreen 